import Vuex from 'vuex'
import Vue from 'vue'
import assessmentDetails from './assessmentDetails'
Vue.use(Vuex)
const store = new Vuex.Store({
	state: {
		/** 用户信息 */
		userInfo: null,
		/** 当前管理员权限列表 */
		powerList: [],
		/** 重试登录回调 */
		tryLoginCallback: null,
		/** 展示登录UI */
		showTryLogin: false,
	},
	mutations: {
		/** 设置用户信息 */
		setUserInfo(state, data) {
			state.userInfo = data
		},

		/** 设置权限列表 */
		setPowerList(state, data) {
			state.powerList = data
		},

		/** 设置重试登录回调 */
		setTryLoginCallback(state, callback) {
			state.tryLoginCallback = callback
		},

		/** 设置是否展示登录UI */
		setShowTryLogin(state, isShow) {
			state.showTryLogin = isShow
		},

	},
	actions: {
	},
	modules: {
		assessmentDetails
	}
})

export default store
